import OrderPersInfoRuForm from './OrderPersInfoRuForm'

export default OrderPersInfoRuForm
